import Typography from '@mui/joy/Typography'

export const CampaignAborted = () => (
    <>
        <Typography color="neutral" level="h3">
            You deleted all the items, create another campaign!
        </Typography>
    </>
)
